import { ShieldCheck, Users, HeartHandshake, Mail } from "lucide-react";
import { FadeIn } from "./Reveal";

const LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/wingman/6a2d24da-fe6b-45e8-b3f6-39d1323c9726/attachments/b8c6d2faf53e4b229e83e258b921f0cf_icon.png";

const PILLARS = [
  { icon: ShieldCheck, label: "Trusted and Safe", testid: "footer-pillar-trusted" },
  {
    icon: Users,
    label: "Join a Growing Community",
    testid: "footer-pillar-community",
  },
  { icon: HeartHandshake, label: "Make an Impact", testid: "footer-pillar-impact" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/10 bg-[#0d1b60] text-white"
    >
      <div className="mx-auto max-w-6xl px-4 pb-24 pt-14 sm:px-6 sm:pb-14 lg:px-8">
        <div className="grid gap-8 sm:grid-cols-3 sm:gap-6">
          {PILLARS.map((pillar) => {
            const Icon = pillar.icon;
            return (
              <FadeIn key={pillar.label}>
                <div
                  data-testid={pillar.testid}
                  className="flex items-center gap-4"
                >
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white/10 text-[#f57c00]">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="text-sm font-bold sm:text-base">
                    {pillar.label}
                  </span>
                </div>
              </FadeIn>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col gap-6 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <a
            href="mailto:edualert.connect@gmail.com"
            data-testid="footer-contact-email"
            className="group flex items-center gap-3 text-sm font-medium text-white/80 transition-colors duration-300 hover:text-white sm:text-base"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 text-[#f57c00]">
              <Mail className="h-4 w-4" />
            </span>
            <span>
              For any queries, contact us at{" "}
              <span className="font-bold text-[#f57c00] underline underline-offset-4 group-hover:text-[#ff9800]">
                edualert.connect@gmail.com
              </span>
            </span>
          </a>
        </div>

        <div className="mt-8 flex flex-col gap-6 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <img
              src={LOGO}
              alt="EduAlert logo"
              data-testid="footer-logo-image"
              className="h-9 w-9 rounded-lg"
            />
            <div>
              <span
                data-testid="footer-brand-name"
                className="font-display block text-base font-extrabold leading-none"
              >
                EduAlert
              </span>
              <span
                data-testid="footer-tagline"
                className="mt-1 block text-[10px] font-semibold uppercase tracking-[0.16em] text-white/50"
              >
                Never Miss an Important Update
              </span>
            </div>
          </div>
          <p
            data-testid="footer-closing-line"
            className="text-sm italic text-white/60"
          >
            Together for a More Informed Generation!
          </p>
        </div>
      </div>
    </footer>
  );
}